// import { isSnYiFuBao, isZhiFuBao } from '@/utils'
let enumObject = {};
// 支付渠道
enumObject.payWay = [
  {
    name: "碳积分支付",
    payChannel: 75,
    method: "Carbonintegral_UnderOrder_Submit",
    frist: false
  }, {
    name: "南京银行支付",
    payChannel: 66,
    method: "NJCB_UnderOrder_Submit",
    frist: false
  },
  {
    name: "非税支付",
    payChannel: 71,
    method: "FS_UnderOrder_Submit",
    frist: false
  },
  {
    name: "农行聚合支付",
    payChannel: 64,
    method: "ABC_UnderOrder_Submit",
    frist: false
  },
  {
    name: "建行聚合支付",
    payChannel: 62,
    method: "CCB_UnderOrder_Submit",
    frist: true
  },
  {
    name: "苏宁支付",
    payChannel: 61,
    method: "Suning_UnderOrder_Submit",
    frist: false
  },
  {
    name: "微信支付",
    payChannel: 1,
    method: "Weixin_UnderOrder_Submit",
    frist: true
  },
  {
    name: "支付宝支付",
    payChannel: 0,
    method: "Alipay_UnderOrder_Submit",
    frist: true
  },
  {
    name: "乐刷支付",
    payChannel: 65,
    method: "Leshua_UnderOrder_Submit",
    frist: true
  },
  {
    name: "银联支付",
    payChannel: 63,
    method: "Yinlian_UnderOrder_Submit",
    frist: true
  }
];
//公众号配置信息
enumObject.providerConfig = {

  // 济南
  JNJT: {
    //微信公众号appid
    AppIds: "wxf3fc55ad88a41d73", //wxeaad8f3b5bb1ae73 wxf3fc55ad88a41d73
    //支付宝生活号appid
    ZfbId: "2021007104619432",//2021002131676145   2021007104619432 
    // 网关 /wechart-service/weChat  /wechart-service
    gateway: "",
    // 客服号码
    servicePhone: "",
    // 开票方
    invoicingParty: "bw",
    // 服务商信息
    provider: {
      providerName: "济南静态交通", //公众号名称
      propagandaInfo: "停车更轻松" //宣传信息
    },
    //支付方式
    payList: [0, 1, 66],
    // 建行支付信息
    payConfigCCB: {},
    payConfigSNYiFuBao: {},
    queryMerchantOrderConfigSNYiFuBao: {},
    //版权
    copyrightInfo: {
      subject: "济南城市静态交通管理运营集团有限公司" //济南城市静态交通管理运营集团有限公司
    },
    CrossPlatform: false, //手机号码注册
    otherConfig: {
      parkType: 2, //停车场类型：1停车场；2路内；
      entreMode: 1, // 0、包含所有收费模式；1、路边收费模式；2、封闭式停车场收费模式
      //其他配置
      paymentCountdown: 60 * 1000, //重新计费时长
      ArrerasTitle: '车辆已离场，历史订单请点击更多。',//重新计费时长
      PayBtn: '我要缴费',//重新计费时长
      GoBill: true,//无订单跳转欠费
    }
  },
  // 济南
  JNCS: {
    //微信公众号appid
    AppIds: "wx2a0ec75a62160ca5", //wxeaad8f3b5bb1ae73 wxf3fc55ad88a41d73
    //支付宝生活号appid
    ZfbId: "2021007104619432",
    // 客服号码
    servicePhone: "15963139481",
    // 开票方
    invoicingParty: "bw",
    // 服务商信息
    provider: {
      providerName: "济南静态交通", //公众号名称
      propagandaInfo: "停车更轻松" //宣传信息
    },
    //支付方式
    payList: [0, 1, 66],
    // 建行支付信息
    payConfigCCB: {},
    payConfigSNYiFuBao: {},
    queryMerchantOrderConfigSNYiFuBao: {},
    //版权  
    copyrightInfo: {
      subject: "济南城市静态交通管理运营集团有限公司" //济南城市静态交通管理运营集团有限公司
    },
    CrossPlatform: false, //手机号码注册
    otherConfig: {
      parkType: 2, //停车场类型：1停车场；2路内；
      entreMode: 1, // 0、包含所有收费模式；1、路边收费模式；2、封闭式停车场收费模式
      //其他配置
      paymentCountdown: 15 * 60 * 1000 //重新计费时长
    }
  },
  // 徽停车
  HTC: {
    //微信公众号appid
    AppIds: "wx37ee299db8d2c099", //徽停车
    //支付宝生活号appid
    ZfbId: "2021002131676145", //徽停车
    // 客服号码
    servicePhone: "暂无",
    // 开票方
    invoicingParty: "bw",
    // 服务商信息
    provider: {
      providerName: "徽停车", //公众号名称
      propagandaInfo: "测试更完美" //宣传信息
    },
    //支付方式
    payList: [1],
    // 建行支付信息
    payConfigCCB: {},
    payConfigSNYiFuBao: {},
    queryMerchantOrderConfigSNYiFuBao: {},
    //版权
    copyrightInfo: {
      subject: "江苏九比特信息系统有限公司" //江苏九比特信息系统有限公司
    },
    CrossPlatform: false, //手机号码注册
    otherConfig: {
      parkType: 2, //停车场类型：1停车场；2路内；
      entreMode: 1, // 0、包含所有收费模式；1、路边收费模式；2、封闭式停车场收费模式
      //其他配置
      paymentCountdown: 15 * 60 * 1000 //重新计费时长
    }
  },


};
//1.苏宁支付类型编码
/**
 * @param {Sting} type
 * @returns {Boolean} 减免:false 实收:true
 */
enumObject.getSNPayType = function (type) {
  switch (type) {
    case "DEBIT_NETPAY": //储蓄卡个人网银
      return true;
    case "CREDIT_NETPAY": //信用卡个人网银
      return true;
    case "DEBIT_B2B": //储蓄卡企业网银
      return true;
    case "CREDIT_B2B": //信用卡企业网银
      return true;
    case "DEBIT_QUICKPAYMENT": //储蓄卡快捷支付
      return true;
    case "CREDIT_QUICKPAYMENT": //信用卡快捷支付
      return true;
    case "DEBIT&CREDIT_NETPAY": //借贷混合个人网银
      return true;
    case "CREDIT_NETPAYINSTALLMENT": //信用卡个人分期付款
      return true;
    case "CREDIT_B2BINSTALLMENT": //信用卡企业分期付款
      return true;
    case "EPP_BALANCE": //苏宁支付余额支付
      return true;
    case "BOF_BALANCE": //零钱宝余额支付
      return true;
    case "EPP_CREDITPAYMENT": //苏宁支付信用付支付
      return true;
    case "BOF_CREDITPAYMENT": //零钱宝零钱贷
      return true;
    case "ACTIVITY_PAYDISCOUNT": //活动支付立减
      return false;
    case "OTHER_NETPAY": //银联在线支付
      return true;
    case "OTHER_QUIICKPAYMENT": //银联手机支付
      return true;
    case "EPP_COUPONS": //苏宁支付电子券
      return false;
    case "EPP_PROMOTION": //苏宁支付促销
      return false;
    default:
      return true;
  }
};
// 获取支付环境
// enumObject.getPayConfig = function (type) {
//     let status = parseInt(type);
//     switch (status) {
//         case isSnYiFuBao():
//             return 61;
//         case isZhiFuBao():
//             return 0;
//         default:
//             return "";
//     }
// };
// 获取性别
enumObject.getSex = function (type) {
  let status = parseInt(type);
  switch (status) {
    case 0:
      return "女";
    case 1:
      return "男";
    default:
      return "未知";
  }
};
// 开票途经
enumObject.getInvoiceType = function (type) {
  let status = parseInt(type);
  switch (status) {
    case 1:
      return "bwInvoice";
    case 2:
      return "hxInvoice";
    case 3:
      return "btInvoice";
    case 4:
      return "zsInvoice";
    default:
      return;
  }
};
// 发票状态
enumObject.getInvoiceStatus = function (type) {
  let status = parseInt(type);
  switch (status) {
    case 1:
      return "开票中";
    case 2:
      return "已开票";
    case 3:
      return "开票失败";
    default:
      return;
  }
};
// 是否展示辅助查询(“查不到订单？点击这里”)
enumObject.getAuxiliaryByMode = function (type) {
  let status = parseInt(type);
  switch (status) {
    case 0:
      return true;
    case 1:
      return true;
    case 2:
      return false;
    default:
      return false;
  }
};
// 获取支付渠道
enumObject.getPayWay = function (type, val) {
  let status = parseInt(type);
  let temp = {};
  for (let i = 0; i < val.length; i++) {
    if (val[i].payChannel === type) {
      temp = JSON.parse(JSON.stringify(val[i]));
    }
  }
  return temp;
};
export default enumObject;
